import React from 'react';
import { Container, Typography, Paper } from '@mui/material';

function KVKKAydinlatma() {
  return (
    <Container maxWidth="lg" sx={{ mt: { xs: '76px', sm: '84px' }, mb: 4 }}>
      <Paper elevation={0} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ mb: 4 }}>
          KİŞİSEL VERİLERİN KORUNMASINA İLİŞKİN BİLGİLENDİRME
        </Typography>

        <Typography paragraph>
          KAYLA BUTİK olarak kişisel verilerinizin 6698 sayılı Kişisel Verilerin Korunması Kanunu'na ("Kanun") uygun olarak işlenerek, muhafaza edilmesine büyük önem veriyoruz. Müşterilerimizi kişisel verileri toplama, işleme, aktarma amacımız ve yöntemlerimiz ve buna bağlı olarak sizlerin Kanun'dan kaynaklanan haklarınızla ilgili bilgilendirmek isteriz.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          1. Kişisel verilerin toplanmasına ilişkin yöntemler
        </Typography>
        <Typography paragraph>
          KAYLA BUTİK olarak, veri sorumlusu sıfatıyla, mevzuattan kaynaklanan yasal yükümlülüklerimiz çerçevesinde; markalarımızın hizmetlerinden faydalanabilmeniz, onayınız halinde kampanyalarımız hakkında sizleri bilgilendirmek, öneri ve şikayetlerinizi kayıt altına alabilmek, sizlere daha iyi hizmet standartları oluşturabilmek, KAYLA BUTİK ticari ve iş stratejilerinin belirlenmesi ve uygulanması gibi amaçlarla kişisel verilerinizi sözlü, internet sitesi, sosyal medya mecraları, mobil uygulamalar ve benzeri vasıtalarla sözlü, yazılı ya da elektronik yöntemlerle toplamaktayız.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          2. Kişisel verilerin işlenmesi ve işleme amaçları
        </Typography>
        <Typography paragraph>
          KAYLA BUTİK olarak, veri sorumlusu sıfatı ile çağrı merkezlerimiz, yazılı iletişim kanallarımız, sosyal medya sayfalarımız, mobil iletişim kanalları, mağaza içi iletişim kanalları ve/veya bunlarla sınırlı olmamak üzere her türlü kanallar aracılığı ile; onayınız dahilinde elde ettiğimiz kişisel ve/veya özel nitelikli kişisel verileriniz tamamen veya kısmen elde edilebilir, kaydedilebilir, saklanabilir, depolanabilir, değiştirilebilir, güncellenebilir, periyodik olarak kontrol edilebilir, yeniden düzenlenebilir, sınıflandırılabilir, işlendikleri amaç için gerekli olan ya da ilgili kanunda öngörülen süre kadar muhafaza edilebilir.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          3. Kişisel Verilerin Aktarılması
        </Typography>
        <Typography paragraph>
          KAYLA BUTİK, söz konusu kişisel verilerinizi sadece; açık rızanıza istinaden veya Kanun'da belirtilen güvenlik ve gizlilik esasları çerçevesinde yeterli önlemler alınmak kaydıyla yurt içinde ve gerekli güvenlik önlemlerinin alınması kaydıyla yurt dışında, Şirket faaliyetlerinin yürütülmesi, veri sahipleri ile müşterilerimiz arasındaki iş ilişkisinin sağlanması ve/veya bu amaçla görüşmeler yapılması, hizmetler, fırsat ve olanaklar sunulması ve hizmet kalitesinin artırılması amacıyla paylaşabilecektir.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          4. Kişisel Veri Sahibinin Hakları
        </Typography>
        <Typography paragraph>
          KAYLA BUTİK ilgili kişilerin aşağıdaki taleplerine karşılık verecektir:
        </Typography>
        <Typography component="div" sx={{ pl: 2 }}>
          a) Kişisel verilerinin işlenip işlenmediğini öğrenme,<br />
          b) İşleme faaliyetinin amaçlarına ilişkin bilgi alma,<br />
          c) Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme,<br />
          d) Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme,<br />
          e) Kanun'a uygun olarak kişisel verilerin silinmesini veya yok edilmesini isteme
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          İletişim Bilgileri
        </Typography>
        <Typography paragraph>
          Ünvanı: KAYLA BUTİK<br />
          Adres: İstanbul, Türkiye<br />
          Telefon: +90 (531) 694 97 44<br />
          E-posta: info@kaylabutik.com
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          Çerez Kullanımı
        </Typography>
        <Typography paragraph>
          Çerezler, sitemizi ziyaret ettiğinizde bilgisayarınız ya da mobil cihazınıza kaydedilen küçük metin dosyalarıdır. Bu çerezler, sitemizin daha iyi hizmet vermesi, daha etkili kullanılması ve sizlere daha uygun içerik ve reklam sunulması amacıyla kullanılmaktadır.
        </Typography>

      </Paper>
    </Container>
  );
}

export default KVKKAydinlatma; 